import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';

export const BiverkningErrandIcon = () => {
    return <FontAwesomeIcon icon={faPencilAlt} fixedWidth={true} />;
};
